import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

export function initDatadogRum({
  applicationId,
  clientToken,
  service,
  env,
  version,
  sessionSampleRate = 100,
  sessionReplaySampleRate = 0,
  privacyLevel = 'mask-user-input',
}: {
  applicationId: string
  clientToken: string
  service: string
  env: string
  version?: string
  sessionSampleRate?: number
  sessionReplaySampleRate?: number
  privacyLevel?: 'mask-user-input' | 'allow'
}) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'us5.datadoghq.com',
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackViewsManually: false,
    trackUserInteractions: true,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: privacyLevel,
    plugins: [reactPlugin({ router: true })],
  })

  datadogRum.startView('app-root')
}
